var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRunning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)",
    stroke: "#0B966B",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.063 3.429l3.375-1.143 6.75 6.857 2.25-2.286"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.625,
    cy: 1.714,
    rx: 1.688,
    ry: 1.714
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.063 11.429L.563 16M11.25 5.143L7.291 9.165a1.154 1.154 0 00.293 1.828l3.104 1.578L7.312 16"
  }))));
}
export default SvgIconRunning;